<template>
<div class="icon">
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 30 30">
    <g fill="none" fill-rule="evenodd" stroke="currentColor" transform="translate(-5,-5)">
      <circle cx="20" cy="20" r="14.25" stroke-width="1.5"/>
      <path stroke-linejoin="round" stroke-width="1.5" d="M23.887 13.228l-6.739 7.795-5.203-2.586"/>
      <path stroke-linejoin="round" d="M19.113 18.63v9.959"/>
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
            d="M26.495 16.043l-2.474-2.79L17.233 11 11 17.978l1.322.653v5.82l6.6 4.138 6.502-1.38"/>
      <path stroke-linecap="round" d="M24.575 21.414h4.242M26.696 19.293v4.242"/>
    </g>
  </svg>
</div>
</template>

<script>
export default {
  name: "MobileMenuApplicationIcon"
}
</script>

